module.exports = __webpack_public_path__ + "static/media/info-icon.012f4040.svg";